// Phone number formatting utilities

// Strip all non-digit characters from phone number
export const stripPhone = (phone) => {
  if (!phone) return '';
  return phone.replace(/\D/g, '');
};

// Format phone number for display (XXX.XXX.XXXX)
export const formatPhoneDisplay = (phone) => {
  const digits = stripPhone(phone);
  if (digits.length === 0) return '';
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}.${digits.slice(3)}`;
  return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 10)}`;
};

// Format phone number as user types (with dots)
export const formatPhoneInput = (value) => {
  const digits = stripPhone(value);
  if (digits.length === 0) return '';
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}.${digits.slice(3)}`;
  return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 10)}`;
};

// Handle phone input change - returns formatted value for display and digits for storage
export const handlePhoneChange = (value) => {
  const digits = stripPhone(value);
  const formatted = formatPhoneInput(digits);
  return {
    formatted,
    digits: digits.slice(0, 10), // Limit to 10 digits
  };
};
